import React from 'react';
import TagesberichtComponent from "../Components/Tagesbericht/Tagesbericht";

const TagesberichtReportPage = (props) => {
    return (
        <>
            <TagesberichtComponent reportView={true}
                                   reportViewWithoutLogin={false}
                                   details={props.history.location.state}
                                   tageState={props.history.location.state.status}
                                   projectID={props.history.location.state.projectID}
                                   tagesID={props.history.location.state.dataID}
                                   pdfAddress={""}


            /></>
    )
}

export default TagesberichtReportPage;


// import React, {memo, useState} from 'react';
//
// //import React, {memo, useEffect, useState} from 'react';
// import {Button, Col, Form, Row} from 'react-bootstrap';
// import moment from "moment";
// import {getToken} from "../Utils/Common";
// //import moment from "moment";
// // import Switch from 'react-switch';
// // import TaetigkeitsberichtReportEmployeeTable
// //     from "../Components/Taetigkeitsbericht/TaetigkeitsberichtReportEmployeeTable";
// // import Auftraggeber from "../Components/Taetigkeitsbericht/Auftraggeber";
// // import Wetter from "../Components/Taetigkeitsbericht/Wetter";
// // import Verortung from "../Components/Taetigkeitsbericht/Verortung";
// // import Taetigkeiten from "../Components/Taetigkeitsbericht/Taetigkeiten";
// // import Geraete from "../Components/Taetigkeitsbericht/Geraete";
// // import TaetigkeitsberichtActionButtonsComponent
// //     from "../Components/Taetigkeitsbericht/TaetigkeitsberichtActionButtonsComponent";
// // import Material from "../Components/Taetigkeitsbericht/Material";
// // import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
// // import {faLock, faPenSquare} from '@fortawesome/free-solid-svg-icons'
// // import TaetigkeitsberichtHeadings from "../Components/Taetigkeitsbericht/TaetigkeitsberichtHeadings";
// // import Signature from "../Components/Taetigkeitsbericht/Signature";
// // import {getToken} from "../Utils/Common";
//
// function TagesberichtPage({history}) {
//     let projectID = history.location.state.projectID
//     let projectName = history.location.state.projectName
//     alert(111)
//     alert(projectID)
//     alert(projectName)
//
//     const [oneDayDate, setOneDayDate] = useState('')
//     const [endDate, setEndDate] = useState('')
//     const [tableonebody, settableonebody] = useState(<></>);
//
//     async function getselectionttabledata(apiBody) {
//             return await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/gettaetigkeitsberichtreport", {
//                 //let response = await fetch("https://yv3616bv8b.execute-api.eu-west-3.amazonaws.com/dev/v1/app/gettaetigkeitsberichtreport", {
//                 method: 'POST', headers: {
//                     'Content-type': 'application/json',
//                 }, body: JSON.stringify({token:getToken(),data:apiBody}),
//             })}
//
// //function TagesberichtPage({history}) {
//
//     // let tID = history.location.state.data
//     // const [taetigkeitsberichtMetaData, setTaetigkeitsberichtMetaData] = useState({});
//     // const [taetigkeitsberichtData, setTaetigkeitsberichtData] = useState({});
//     // const [originState, setOriginState] = useState(true);
//     //
//     // const [orgTD, setOrgTD] = useState({})
//     // const [revTD, setRevTD] = useState({})
//     //
//     // const [pID, setPID] = useState(sessionStorage.getItem('projectID'))
//     //
//     // const [isChange, setIsChange] = useState(false)
//
//
//     /*function handleChange(checked) {
//         setOriginState(checked);
//     }*/
//
//     // useEffect(() => {
//     //
//     //     let apiBody = {
//     //         "token": getToken(),
//     //         "data": {
//     //             "taetigkeitsberichtDataID": tID
//     //         }
//     //     }
//     //
//     //     async function getTData() {
//     //         let response = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/gettaetigkeitsberichtreport", {
//     //             //let response = await fetch("https://yv3616bv8b.execute-api.eu-west-3.amazonaws.com/dev/v1/app/gettaetigkeitsberichtreport", {
//     //             method: 'POST', headers: {
//     //                 'Content-type': 'application/json',
//     //             }, body: JSON.stringify(apiBody),
//     //         })
//     //
//     //         let data = await response.json()
//     //
//     //         setTaetigkeitsberichtData(data.taetigkeitsberichtorg)
//     //         setOrgTD(data.taetigkeitsberichtorg)
//     //         setRevTD(data.taetigkeitsberichtrev)
//     //
//     //         setPID(data.taetigkeitsberichtrev.projectID)
//     //
//     //     }
//     //
//     //     getTData().then(r => r)
//     //
//     // }, [])
//     //
//     // useEffect(() => {
//     // }, [taetigkeitsberichtData])
//     //
//     // useEffect(() => {
//     //     setTaetigkeitsberichtMetaData({
//     //         "id": 1,
//     //         "projectID": "PROJECT001",
//     //         "organisationID": "ORG001",
//     //         "taetigkeitsberichtDataID": "TD001",
//     //         "creatorName": "Name 1",
//     //         "creatorFirstName": "F Name 1",
//     //         "creatorLastName": "L Name 1",
//     //         "status": "offen",
//     //         "date": "15.11.2022",
//     //         "approvalData": {
//     //             "approvalFirstName": "First Name 1", "approvalLastName": "Last Name 1", "approvalDate": "16.11.2022"
//     //         }
//     //     })
//     // }, []);
//     //
//     // useEffect(() => {
//     //     if (originState === false) {
//     //         setTaetigkeitsberichtData(revTD)
//     //
//     //     } else {
//     //         setTaetigkeitsberichtData(orgTD)
//     //     }
//     // }, [originState]);
//     //
//     // useEffect(() => {
//     // }, [orgTD, revTD])
//
//
//     return (<div className="handwai-dark">
//             <div style={{
//                 width: '100%', height: 880, overflow: 'auto', overflowX: 'hidden',
//             }}>
//                 <Row
//                     className="handwai-text-label-normal">
//                     <Col/>
//                     <Col/>
//                     <Col/>
//                     <Col>
//
//                         <br/>
//
//                         <div style={{
//                             display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'
//                         }}>
//
//
//                             {/*<FontAwesomeIcon icon={faLock} style={{*/}
//                             {/*    fontSize: '24px', color: originState ? '#1abc9c' : '#7c7c7c'*/}
//                             {/*}}/>*/}
//
//                             &nbsp;
//                             {/*<Switch*/}
//                             {/*    onChange={handleChange}*/}
//                             {/*    checked={originState}*/}
//                             {/*    onColor="#1abc9c"*/}
//                             {/*    offColor="#1abc9c"*/}
//                             {/*    onHandleColor="#7c7c7c"*/}
//                             {/*    offHandleColor="#7c7c7c"*/}
//                             {/*    handleDiameter={30}*/}
//                             {/*    uncheckedIcon={false}*/}
//                             {/*    checkedIcon={false}*/}
//                             {/*    boxShadow="0px 1px 1x rgba(0, 0, 0)"*/}
//                             {/*    activeBoxShadow="0px 0px 1px rgba(0, 0, 0)"*/}
//                             {/*    height={20}*/}
//                             {/*    width={48}*/}
//                             {/*/>{' '}*/}
//                             &nbsp;
//
//                             {/*<FontAwesomeIcon icon={faPenSquare} style={{*/}
//                             {/*    fontSize: '24px', color: originState ? '#7c7c7c' : '#1abc9c'*/}
//                             {/*}}/>*/}
//
//                         </div>
//                     </Col>
//                 </Row>
//
//                 {/*{taetigkeitsberichtMetaData.id !== undefined && <TaetigkeitsberichtHeadings*/}
//                 {/*    taetigkeitsberichtMetaData={taetigkeitsberichtMetaData}*/}
//                 {/*/>}*/}
//                 <br/>
//                 <br/>
//                 <Row>
//                     <Col/>
//                     <Col sm={5}>
//                         {/*{taetigkeitsberichtData?.coworkers !== undefined && <TaetigkeitsberichtReportEmployeeTable*/}
//                         {/*    setIsChange={setIsChange}*/}
//                         {/*    originState={originState}*/}
//                         {/*    tEmployeeData={taetigkeitsberichtData.coworkers}*/}
//                         {/*    defaultStartTime={taetigkeitsberichtData.coworkers[0]?.workHours.startTime}*/}
//                         {/*    defaultEndTime={taetigkeitsberichtData.coworkers[0]?.workHours.endTime}*/}
//                         {/*/>}*/}
//                     </Col>
//                     <Col/>
//                     <Col sm={3}>
//                         {/*<Auftraggeber*/}
//                         {/*    setIsChange={setIsChange}*/}
//                         {/*    pID={pID}*/}
//                         {/*    originState={originState}*/}
//                         {/*    auftraggeberData={taetigkeitsberichtData?.auftraggeber}/>*/}
//                     </Col>
//                     <Col/>
//                     <Col sm={2}>
//                         {/*<Wetter*/}
//                         {/*    setIsChange={setIsChange}*/}
//                         {/*    originState={originState}*/}
//                         {/*    wetterData={taetigkeitsberichtData?.wetter}/>*/}
//                     </Col>
//                     <Col/>
//                 </Row>
//                 <br/>
//                 <Row>
//                     <Col/>
//                     <Col sm={4} className="middleLine">
//
//                         <Form id="upload-lv">
//                             <Row>
//                                 <Col md={1}>
//
//                                     <td><input
//                                         //disabled={!isProjectAvailable()}
//                                         // onChange={event => {
//                                         //     setOneDayTickStatus(event.target.checked)
//                                         //     if (event.target.checked) {
//                                         //         setEndDate('')
//                                         //     }
//                                         // }}
//                                         className="userdetailscheckbox"
//                                         type="checkbox"
//                                         id="checkbox"
//                                         //defaultChecked={oneDayTickStatus}
//                                     /></td>
//                                 </Col>
//                                 <Col md={1}>
//                                     <Form.Label className={"aufmasText"}>
//                                         Ein Tag
//                                     </Form.Label>
//                                 </Col>
//
//                                 <Col md={2}>
//
//                                     <Form.Group controlId="formGroupSingleDate">
//
//                                         <Form.Control
//                                             //disabled={!isOneDayDateActive()}
//                                             type="date"
//                                             className="handwai-input"
//                                             //style={addWidth555}
//                                             onChange={(event) => {
//                                                 let eventValue = event.target.value;
//                                                 let date = moment(eventValue).format("DD-MM-YYYY")
//                                                 setOneDayDate(date);
//                                             }}
//                                         />
//                                     </Form.Group>
//                                 </Col>
//                                 <Col md={2}>
//                                     {/*{!oneDayTickStatus && */}
//                                     <Form.Group controlId="formGroupEndDate">
//                                         <Form.Control
//                                             //disabled={!isTwoDayDateActive()}
//                                             type="date"
//                                             className="handwai-input"
//                                             //style={addWidth555}
//                                             onChange={(event) => {
//                                                 let eventValue = event.target.value;
//                                                 let date = moment(eventValue).format("DD-MM-YYYY")
//                                                 setEndDate(date);
//                                             }}
//                                         />
//                                     </Form.Group>
//                                 </Col>;
//
//                                 <Col md={2}>
//                                     <Button
//                                         //disabled={!isValid()}
//                                         onClick={async () => {
//                                             let apiBody = {
//                                         projectInformation: "projectInformation.value",
//                                         startDate: oneDayDate,
//                                         endDate: endDate
//                                     }
//                                             let result = await getselectionttabledata(apiBody)
//                                             console.log(result)
//
//                                             settableonebody(<></>)
//                                             alert(oneDayDate)
//                                             alert(endDate)
//                                         }
//                                             // let apiBody = {
//                                             //     projectInformation: projectInformation.value,
//                                             //     startDate: oneDayDate,
//                                             //     endDate: endDate
//                                             // }
//                                             // let result = await getaufmasstabledata(apiBody)
//                                             // setaufmassapiresult(result.data)
//                                             // fillTable(result.data)
//                                             // prepareAufmassTableBody(aufmassapiresult)
//                                         }
//                                         className="handwai-btn-create"
//                                         variant="success"
//                                         //style={addWidth555}
//
//                                         //size="lg"
//                                         //block
//                                     >
//                                         Anzeigen
//                                     </Button>
//                                 </Col>
//
//                             </Row>
//
//                         </Form>
//
//                         <table id='tableone'
//                                className='table'>
//                             <thead>
//                             <tr>
//                                 <th data-sortable='true' data-searchable='true'>
//                                     Auswahl
//                                 </th>
//                                 <th data-sortable='true' data-searchable='true'>
//                                     Datum
//                                 </th>
//                                 <th data-sortable='true' data-searchable='true'>
//                                     Typ
//                                 </th>
//                                 <th data-sortable='true' data-searchable='true'>
//                                     Ersteller
//                                 </th>
//
//                             </tr>
//                             </thead>
//                             <tbody
//                                 className='handwai-text-label-normal'>{tableonebody}</tbody>
//                         </table>
//
//
//                         {/*//style={{borderRight:'20px',color:"white"}}*/}
//                         {/*<label className="handwai-text-label-main,middleLine">{"Tagesbericht"}</label>*/}
//                     </Col>
//
//                     <Col sm={7}>
//
//                         <Row>
//                             <label className="handwai-text-label-main,middleLine">{"Project Tagesbericht"}</label>
//                         </Row>
//
//                         <Row>
//                             <label
//                                 className="handwai-text-label-main,middleLine">{"Leistungsübersicht:31.06.2023"}</label>
//                         </Row>
//
//                         <Row>
//                             <Col>
//                                 <label
//                                     className="handwai-text-label-main,middleLine">{"Anwensenheit: 07:30 - 18:15"}</label>
//
//                             </Col>
//                             <Col>
//                                 <label
//                                     className="handwai-text-label-main,middleLine">{"Wetter-Innen:"}</label>
//
//                             </Col>
//                             <Col>
//                                 <label
//                                     className="handwai-text-label-main,middleLine">Wetter-Außen:{12345}</label>
//                             </Col>
//
//                         </Row>
//
//                         <Row>
//                             <Col>Anwesenheit Vor-Ort</Col>
//                         </Row>
//                         <Row>
//                             <Col>
//
//                                 <table id='tabletwo'
//                                className='table'>
//                             <thead>
//                             <tr>
//                                 <th data-sortable='true' data-searchable='true'>
//                                     Experten
//                                 </th>
//                                 <th data-sortable='true' data-searchable='true'>
//                                     Anzahl
//                                 </th>
//                                 <th data-sortable='true' data-searchable='true'>
//                                     Stunden
//                                 </th>
//
//                             </tr>
//                             </thead>
//                             <tbody
//                                 className='handwai-text-label-normal'>{tableonebody}</tbody>
//                         </table>
//
//                             </Col>
//                             <Col>
//
//                                 <table id='tablethree'
//                                className='table'>
//                             <thead>
//                             <tr>
//                                 <th data-sortable='true' data-searchable='true'>
//                                     Anwesendheit Auftraggeber
//                                 </th>
//
//
//                             </tr>
//                             </thead>
//                             <tbody
//                                 className='handwai-text-label-normal'>{tableonebody}</tbody>
//                         </table>
//
//                             </Col>
//                         </Row>
//
//                         <Row>Tätigkeiten(Tätigkeitsbericht)</Row>
//                         <Row>
//                             <table id='tablefour'
//                                className='table'>
//                             <thead>
//                             <tr>
//                                 <th data-sortable='true' data-searchable='true'>
//                             Position
//                         </th>
//                         <th data-sortable='true' data-searchable='true'>
//                             Bezeichnung
//                         </th>
//                         <th data-sortable='true' data-searchable='true'>
//                             Einheit
//                         </th>
//                         <th data-sortable='true' data-searchable='true'>
//                             Menge
//                         </th>
//
//
//                             </tr>
//                             </thead>
//                             <tbody
//                                 className='handwai-text-label-normal'>{tableonebody}</tbody>
//                         </table>
//                         </Row>
//
//                         <Row>Geräte</Row>
//                         <Row>
//                             <table id='tablefive'
//                                className='table'>
//                             <thead>
//                             <tr>
//                                 <th data-sortable='true' data-searchable='true'>
//                                     Anwesendheit Auftraggeber
//                                 </th>
//
//
//                             </tr>
//                             </thead>
//                             <tbody
//                                 className='handwai-text-label-normal'>{tableonebody}</tbody>
//                         </table>
//                         </Row>
//
//
//                     </Col>
//                     <Col/>
//                 </Row>
//                 <br/>
//                 <Row>
//                     <Col/>
//                     <Col sm={2} md={2}>
//                         {/*<Verortung*/}
//                         {/*    setIsChange={setIsChange}*/}
//                         {/*    originState={originState}*/}
//                         {/*    taetigkeitsberichtData={taetigkeitsberichtData}*/}
//                         {/*    setTaetigkeitsberichtData={setTaetigkeitsberichtData}*/}
//                         {/*    verortungData={taetigkeitsberichtData?.verortung}*/}
//                         {/*/>*/}
//                     </Col>
//                     <Col sm={2} md={2}/>
//                     <Col sm={7} md={7}>
//                         {/*<Taetigkeiten*/}
//                         {/*    setIsChange={setIsChange}*/}
//                         {/*    originState={originState}*/}
//                         {/*    taetigkeitsberichtData={taetigkeitsberichtData}*/}
//                         {/*    setTaetigkeitsberichtData={setTaetigkeitsberichtData}*/}
//                         {/*    taetigkeitenData={taetigkeitsberichtData?.taetigkeiten}/>*/}
//                     </Col>
//                     <Col/>
//                 </Row>
//                 <br/> <br/>
//                 <Row>
//                     <Col/>
//                     <Col sm={7}>
//                         {/*<Material*/}
//                         {/*    setIsChange={setIsChange}*/}
//                         {/*    originState={originState}*/}
//                         {/*          taetigkeitsberichtData={taetigkeitsberichtData}*/}
//                         {/*          setTaetigkeitsberichtData={setTaetigkeitsberichtData}*/}
//                         {/*          materialData={taetigkeitsberichtData?.material}/>*/}
//                     </Col>
//                     <Col sm={4}>
//                         {/*<Geraete*/}
//                         {/*    setIsChange={setIsChange}*/}
//                         {/*    originState={originState}*/}
//                         {/*    geraeteData={taetigkeitsberichtData?.device}/>*/}
//                     </Col>
//                     <Col/>
//                 </Row>
//
//                 <br/> <br/>
//                 <Row>
//
//                     <Col/>
//                     <Col sm={7}>
//                         {/*{taetigkeitsberichtData?.coworkers !== undefined &&*/}
//                         {/*<Signature type={'creatorSign'}*/}
//                         {/*           name={taetigkeitsberichtData?.coworkers[0]?.firstName + " " +*/}
//                         {/*           taetigkeitsberichtData?.coworkers[0]?.lastName}*/}
//                         {/*           image={taetigkeitsberichtData?.creatorSignature}/>*/}
//                         {/*}*/}
//                     </Col>
//
//                     <Col sm={4}>
//                     </Col>
//                     <Col/>
//                 </Row>
//
//             </div>
//
//
//             <br/>
//
//             <div className="horizontal-line"></div>
//             <div style={{
//                 width: '100%',
//             }}>
//                 {/*<TaetigkeitsberichtActionButtonsComponent*/}
//                 {/*    isChange={isChange}*/}
//                 {/*    setIsChange={setIsChange}*/}
//                 {/*    originState={originState}*/}
//                 {/*    taetigkeitsberichtData={taetigkeitsberichtData}*/}
//                 {/*/>*/}
//             </div>
//             <br/>
//         </div>
//
//     );
// }
//
// export default memo(TagesberichtPage);